// import { createSelector } from "@reduxjs/toolkit";

export const selectAnnouncements = (state) => state.video.announcements;
